export enum InvestigationReportAttestationStatus {
	NotCreated = "NOT_CREATED",
	Drafting = "DRAFTING",
	Awaiting = "AWAITING_ATTESTATION",
	Attested = "ATTESTED",
	WithReservation = "ATTESTED_WITH_RESERVATION",
	Automatic = "AUTOMATIC_ATTESTATION",
	Uploaded = "UPLOADED",
	SignedRequired = "SIGNED_REQUIRED",
	NonResponse = "NON_RESPONSE",
}
